<template>
  <fragment>
    <tr>
      <td>
        <strong>Cobrar juros e multa</strong>
      </td>
      <td class="charges-rule__form">
        <loading v-if="loading" full-parent />
        <select-field
          v-model="form.get('type').value"
          :options="chargesRuleTypes"
          @input="updateChargesByEvent"
        />
        <div v-if="form.get('type').value !== 'disabled'">
          <input-field
            label="Taxa de juros"
            input-group-text-append="%"
            placeholder="Porcentagem da taxa de juros"
            :disabled="form.get('type').value == 'default'"
            :mask="'#.##'"
            v-model="form.get('interestRate').value"
            :errors="form.get('interestRate').errors"
            @input="emitFormFieldChanged('interestRate')"
          />
          <input-field
            label="Taxa de multa"
            input-group-text-append="%"
            placeholder="Porcentagem da taxa de multa"
            :disabled="form.get('type').value == 'default'"
            :mask="'#.##'"
            v-model="form.get('penaltyRate').value"
            :errors="form.get('penaltyRate').errors"
            @input="emitFormFieldChanged('penaltyRate')"
          />
          <select-field
            label="Base de cálculo"
            :disabled="form.get('type').value == 'default'"
            :options="chargesBasedOnTypes"
            v-model="form.get('chargesBasedOn').value"
            :errors="form.get('chargesBasedOn').errors"
            @input="emitFormFieldChanged('chargesBasedOn')"
          />
        </div>
      </td>
    </tr>
  </fragment>
</template>
<script>
import { InputField, SelectField } from 'components/form';
import EnumsService from 'services/EnumsService';
import Loading from 'components/Loading';

export default {
  components: {
    InputField,
    SelectField,
    Loading,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultChargesRule: {
        interestRate: '1.00',
        penaltyRate: '2.00',
        chargesBasedOn: 'full_amount',
        applyCharges: true,
      },
      chargesRuleTypes: [
        { value: 'default', label: 'Configuração padrão' },
        { value: 'custom', label: 'Personalizada' },
        { value: 'disabled', label: 'Desabilitada' },
      ],
      chargesBasedOnTypes: [],
      loading: false,
    };
  },
  mounted() {
    this.loading = true;

    EnumsService.getChargesBasedOnTypes()
      .then((chargesBasedOnTypes) => {
        this.chargesBasedOnTypes = chargesBasedOnTypes;
      })
      .catch(() => {
        this.$router.push('/');
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    updateChargesByEvent(value) {
      switch (value) {
        case 'custom':
          this.form.get('applyCharges').value = true;
          break;
        case 'disabled':
          this.form.get('applyCharges').value = false;
          this.form.get('chargesBasedOn').value = this.defaultChargesRule.chargesBasedOn;
          break;
        default:
          this.form.get('interestRate').value = this.defaultChargesRule.interestRate;
          this.form.get('penaltyRate').value = this.defaultChargesRule.penaltyRate;
          this.form.get('chargesBasedOn').value = this.defaultChargesRule.chargesBasedOn;
          this.form.get('applyCharges').value = this.defaultChargesRule.applyCharges;
          break;
      }
    },
    emitFormFieldChanged(field) {
      this.$emit('form-field-changed', { [field]: this.form.get(field).value });
    },
  },
};
</script>
<style lang="scss" scoped>
.charges-rule__form {
  position: relative;
}
</style>
